/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Die Form eines Feldes. Bei Badge und Button: Pille (rund) oder Button
 * (eckig mit Rahmen). Beim Bild: rund oder abgerundet. Die Maske bietet
 * je Feld nur die zwei an, die dort Sinn ergeben.
 * @export
 */
export const DatabaseBannerFeldForm = {
    Pille: 'PILLE',
    Button: 'BUTTON',
    Rund: 'RUND',
    Abgerundet: 'ABGERUNDET'
} as const;
export type DatabaseBannerFeldForm = typeof DatabaseBannerFeldForm[keyof typeof DatabaseBannerFeldForm];


export function DatabaseBannerFeldFormFromJSON(json: any): DatabaseBannerFeldForm {
    return DatabaseBannerFeldFormFromJSONTyped(json, false);
}

export function DatabaseBannerFeldFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBannerFeldForm {
    return json as DatabaseBannerFeldForm;
}

export function DatabaseBannerFeldFormToJSON(value?: DatabaseBannerFeldForm | null): any {
    return value as any;
}

